import { createSelector } from 'reselect';
import { RootState } from '..';
import { NavigationState } from './types';

export const navigationItemSelector = createSelector(
  (state: RootState) => state.navigation,
  (navigation: NavigationState) => navigation.selectedNavigationItem
);
